/**
 * Converte um Record de enum para um array de CheckboxGroupOption.
 * Mapeia automaticamente todas as entradas do record.
 * Qualquer mudança no enum ou no record será refletida automaticamente.
 *
 * @template T - O tipo do enum
 * @param enumRecord - O Record que mapeia valores do enum para suas labels
 * @returns Array de opções formatadas para uso em checkbox groups
 *
 * @example
 * ```typescript
 * enum Status {
 *   Active = 0,
 *   Inactive = 1
 * }
 *
 * const STATUS_RECORD: Record<Status, string> = {
 *   [Status.Active]: 'Ativo',
 *   [Status.Inactive]: 'Inativo'
 * };
 *
 * const options = enumRecordToCheckboxOptions(STATUS_RECORD);
 * // Resultado: [
 * //   { value: 0, label: 'Ativo' },
 * //   { value: 1, label: 'Inativo' }
 * // ]
 * ```
 */
//TODO: Importing CheckboxGroupOption from UI library was causing circular dependency issues.
export function enumRecordToCheckboxOptions<T extends number | string>(
  enumRecord: Record<T, string>
): { value: T; label: string }[] {
  return Object.entries(enumRecord)
    .map(([value, label]) => ({
      value: value as unknown as T,
      label: label as string
    }))
    .sort((a, b) => a.label.toString().localeCompare(b.label.toString()));
}
